export const GET_PERFORMANCE_DETAILS_REQUEST_START = 'GET_PERFORMANCE_DETAILS_REQUEST_START';
export const GET_PERFORMANCE_DETAILS_REQUEST_FAIL = 'GET_PERFORMANCE_DETAILS_REQUEST_FAIL';
export const GET_PERFORMANCE_DETAILS_REQUEST_SUCCESS = 'GET_PERFORMANCE_DETAILS_REQUEST_SUCCESS';
